import * as React from 'react';
import { AuthCard } from 'ts/components/Card';
import { Heading } from 'ts/components/Heading';
import { Button } from '@origin-digital/style-guide';
import { InfoText } from 'ts/components/InfoText';
import { Page } from '../../../../components/Page';

interface CallCentreResetPasswordThankyouViewProps {
  nextAction: () => void;
}

const CallCentreResetPasswordThankyouView: React.FC<CallCentreResetPasswordThankyouViewProps> = ({
  nextAction,
}) => (
  <Page>
    <AuthCard>
      <>
        <Heading text="We've reset your password" />
        <InfoText text="You can log in to My Account with your email address and your new password." />
        <Button text="Log in" block={true} onClick={nextAction} />
      </>
    </AuthCard>
  </Page>
);

export { CallCentreResetPasswordThankyouView };
